import { getIndexName } from '../../../../../constants';
import { LOCALIZED_PATHS } from '../../../../../utils/constants/url-constants';
import { generateUrlFromIndexUiState } from '../../../../../utils/search-router/url-handling';

type SupportedLocale = 'en' | 'fi' | 'sv';

function toSupportedLocale(locale: string): SupportedLocale {
  const normalized = locale.toLowerCase();
  if (normalized === 'fi' || normalized === 'sv') return normalized;
  return 'en';
}

export function buildSrpFacetHref(locale: string, facetKey: string, value: string): string {
  const supportedLocale = toSupportedLocale(locale);
  const trimmedValue = value.trim();
  if (!trimmedValue) {
    return `/${supportedLocale}/${LOCALIZED_PATHS[supportedLocale].jobs}`;
  }

  return generateUrlFromIndexUiState(
    {
      refinementList: {
        [facetKey]: [trimmedValue],
      },
    },
    getIndexName(supportedLocale),
    `/${supportedLocale}/${LOCALIZED_PATHS[supportedLocale].jobs}`,
  );
}
